module.exports = __webpack_public_path__ + "img/Radfahren.e3ab778a.jpg";